import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';

interface IProps {
  activeStep: number;
  numberOfSteps: number;
  docTitle: string;
}

export const VerificationCenterHeader = ({ activeStep, numberOfSteps, docTitle }: IProps) => {
  const { t } = useTranslation();
  return (
    <>
      {numberOfSteps > 1 && (
        <Heading.H10 id='BVC__stepper' className='text-text-main-secondary mb-[16px] '>
          {t('pages.verificationCenter.stepper', {
            step: activeStep + 1,
            totalSteps: numberOfSteps,
          })}
        </Heading.H10>
      )}

      <Heading.H5 id='required-doc__title' fontWeight={FontWeight.MEDIUM}>
        {docTitle}
      </Heading.H5>
    </>
  );
};
